
import React, { useEffect } from 'react';
import ServiceCard from '../components/ServiceCard';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const animations = ['fade-down', 'fade-left', 'fade-right', 'fade-up'];

  const services = [
    { title: "Residential Interior", shortDesc: "Warm, welcoming, and beautiful interiors.", image: "/images/residential-interior.jpg", id: "residential" },
    { title: "Commercial Interiors", shortDesc: "Professional and inspiring workspaces.", image: "/images/commercial-interior.jpg", id: "commercial" },
    { title: "Texture & Finishes", shortDesc: "Luxury walls with special textures.", image: "/images/texture-finish.jpg", id: "texture" },
    { title: "Color Consultation", shortDesc: "Expert advice for perfect color schemes.", image: "/images/color-consultation.jpg", id: "color" },
    { title: "Wallpaper & Wall Art", shortDesc: "Bold and creative wall designs.", image: "/images/wallpaper-art.jpg", id: "wallpaper" }
  ];

  return (
    <div style={{ padding: '40px 20px', backgroundColor: '#f2f5fa', textAlign: 'center', paddingTop: "120px" }}>
      <h2 style={{ color: '#008080', marginBottom: '30px', fontSize: '28px' }} data-aos="fade-down">Our Services</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {services.map((s, i) => (
          <div key={i} data-aos={animations[i % animations.length]} data-aos-delay={i * 100}>
            <ServiceCard {...s} />
          </div>
        ))}
      </div>
    </div>
  );
}

// import React from 'react';
// import { useParams } from 'react-router-dom';
// import GalleryImage from '../components/galleryimages';

// import Testimonials from '../components/TestimonialCard';
// const serviceData = {
//   exterior: {
//     title: "Exterior Projects",
//     description: "We specialize in large-scale exterior painting projects like factories, warehouses, and commercial buildings.",
//     images: [
//       "/Gallerypics/170ff44e2859fd1e9f2cf19776ef55ab.jpg",
//       "/Gallerypics/tennis-court-render-3d-illustration.jpg",
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//     '/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg',
//     '/Gallerypics/51af35d219d4ee84b5507f4680d57c9f.jpg',
//     '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//     '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/Javed.jpg',
//       '/Gallerypics/Servicepics/photo-1454165804606-c3d57bc86b40.jpeg',
//       '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     ]
//   },
//   ceiling: {
//     title: "Ceiling Coating",
//     description: "Expert coatings for ceilings in commercial and residential buildings.",
//     images: [
//       "/Gallerypics/photo-1631679706909-1844bbd07221.jpeg",
//       "/Gallerypics/tennis-court-render-3d-illustration.jpg",
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//     '/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg',
//     '/Gallerypics/51af35d219d4ee84b5507f4680d57c9f.jpg',
//     '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//     '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/Javed.jpg',
//       '/Gallerypics/Servicepics/photo-1454165804606-c3d57bc86b40.jpeg',
//       '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     ]
//   },
//    marquee: {
//     title: "Marquee Painting",
//     description: "Expert coatings for ceilings in commercial and residential buildings.",
//     images: [
//       "/Gallerypics/photo-1631679706909-1844bbd07221.jpeg",
//       "/Gallerypics/tennis-court-render-3d-illustration.jpg",
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//     '/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg',
//     '/Gallerypics/51af35d219d4ee84b5507f4680d57c9f.jpg',
//     '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//     '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/Javed.jpg',
//       '/Gallerypics/Servicepics/photo-1454165804606-c3d57bc86b40.jpeg',
//       '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     ]
//   },
//    flour: {
//     title: "Flour Mills",
//     description: "Expert coatings for ceilings in commercial and residential buildings.",
//     images: [
//       "/Gallerypics/photo-1631679706909-1844bbd07221.jpeg",
//       "/Gallerypics/tennis-court-render-3d-illustration.jpg",
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//     '/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg',
//     '/Gallerypics/51af35d219d4ee84b5507f4680d57c9f.jpg',
//     '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//     '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/Javed.jpg',
//       '/Gallerypics/Servicepics/photo-1454165804606-c3d57bc86b40.jpeg',
//       '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     ]
//   },
//    games: {
//     title: "Games Area",
//     description: "Expert coatings for ceilings in commercial and residential buildings.",
//     images: [
//       "/Gallerypics/photo-1631679706909-1844bbd07221.jpeg",
//       "/Gallerypics/tennis-court-render-3d-illustration.jpg",
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//     '/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg',
//     '/Gallerypics/51af35d219d4ee84b5507f4680d57c9f.jpg',
//     '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//     '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/Javed.jpg',
//       '/Gallerypics/Servicepics/photo-1454165804606-c3d57bc86b40.jpeg',
//       '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',

//     ]
//   },
//    commercial: {
//     title: "INTERIOR ",
//     description: "Expert coatings for ceilings in commercial and residential buildings.",
//     images: [
//       "/Gallerypics/photo-1631679706909-1844bbd07221.jpeg",
//       "/Gallerypics/tennis-court-render-3d-illustration.jpg",
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//     '/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg',
//     '/Gallerypics/51af35d219d4ee84b5507f4680d57c9f.jpg',
//     '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//     '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/Javed.jpg',
//       '/Gallerypics/Servicepics/photo-1454165804606-c3d57bc86b40.jpeg',
//       '/Gallerypics/d0462b18b4fedf498b5d815f299dc04e.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//       '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//       '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
//     ]
//   }
   

  // Add more like 'interior', 'games', etc.
// };

// export default function ServiceDetail() {
    
//   const { id } = useParams();
//   const service = serviceData[id];

//   if (!service) return <p style={{ padding: 50 }}>Service not found.</p>;

//   return (
//     <div style={{ padding: '40px 20px' ,marginTop:"120px" ,textAlign:"center"}}>
//       <h2 style={{ color: '#008080' }}>{service.title}</h2>
//       <p>{service.description}</p>
      
      {/* <div style={{     columnCount: 4,
    columnGap: '1rem',
    padding: '20px', }}>
        {service.images.map((img, i) => (
          <img key={i} src={img} alt='images' style={{ 
        width: '100%',
        borderRadius: '8px',
        marginBottom: '1rem',
        breakInside: 'avoid'}} />
        ))}
      </div> */}
//       <GalleryImage
//   images={service.images.map((src) => ({ src }))}
// />

//       <Testimonials/>
    
//     </div>
    
//   );
// }

